/**
 * Class to hold data that the account recovery redirect component may not necessarily care about.
 */
export class WebNGRedirectExtras {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any,no-undef */
  [key: string]: any;
}
